module.exports = __webpack_public_path__ + "img/shangqiuAppImage.c2c82d4c.png";